export enum RecommendationLevels {
  tooHigh = 'tooHigh',
  slightlyHigh = 'slightlyHigh',
  slightlyLow = 'slightlyLow',
  tooLow = 'tooLow'
}
